// constants
import { ObservationActionTypes } from './constants';
import { Observation as ObservationDataType, ObservationStatus, ObservationReport } from 'src/types/observation';

export type ObservationActionType = {
    type:
        | ObservationActionTypes.API_RESPONSE_SUCCESS
        | ObservationActionTypes.API_RESPONSE_ERROR
        | ObservationActionTypes.GET_OBSERVATIONS
        | ObservationActionTypes.GET_OBSERVATIONS_STATUS
        | ObservationActionTypes.GET_OBSERVATION_REPORT
        | ObservationActionTypes.ADD_OBSERVATION
        | ObservationActionTypes.EDIT_OBSERVATION
        | ObservationActionTypes.GET_OBSERVATION
        | ObservationActionTypes.GET_OBSERVATION_LIST
        | ObservationActionTypes.DELETE_OBSERVATION
        | ObservationActionTypes.SEND_EMAIL_OBSERVATION
        | ObservationActionTypes.RESET
        | ObservationActionTypes.RESET_SUCCESS
        | ObservationActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const observationApiResponseSuccess = (
    actionType: string,
    data:
        | ObservationDataType
        | ObservationDataType[]
        | ObservationReport
        | ObservationReport[]
        | ObservationStatus[]
        | []
        | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): ObservationActionType => ({
    type: ObservationActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const observationApiResponseError = (
    actionType: string,
    data:
        | ObservationDataType
        | ObservationDataType[]
        | ObservationReport
        | ObservationReport[]
        | ObservationStatus[]
        | []
        | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): ObservationActionType => ({
    type: ObservationActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addObservation = (params: any): ObservationActionType => ({
    type: ObservationActionTypes.ADD_OBSERVATION,
    payload: params,
});

export const editObservation = (params: any): ObservationActionType => ({
    type: ObservationActionTypes.EDIT_OBSERVATION,
    payload: params,
});

export const getObservation = (params: any): ObservationActionType => ({
    type: ObservationActionTypes.GET_OBSERVATION,
    payload: params,
});

export const getObservations = (params: any): ObservationActionType => ({
    type: ObservationActionTypes.GET_OBSERVATIONS,
    payload: params,
});

export const getObservationStatus = (params: any): ObservationActionType => ({
    type: ObservationActionTypes.GET_OBSERVATIONS_STATUS,
    payload: params,
});

export const getObservationList = (params: any): ObservationActionType => ({
    type: ObservationActionTypes.GET_OBSERVATION_LIST,
    payload: params,
});

export const getObservationReport = (params: any): ObservationActionType => ({
    type: ObservationActionTypes.GET_OBSERVATION_REPORT,
    payload: params,
});

export const deleteObservation = (params: any): ObservationActionType => ({
    type: ObservationActionTypes.DELETE_OBSERVATION,
    payload: params,
});

export const sendEmailObservation = (params: any): ObservationActionType => ({
    type: ObservationActionTypes.SEND_EMAIL_OBSERVATION,
    payload: params,
});

export const resetObservation = (): ObservationActionType => ({
    type: ObservationActionTypes.RESET,
    payload: {},
});

export const resetObservationSuccess = (): ObservationActionType => ({
    type: ObservationActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetObservationError = (): ObservationActionType => ({
    type: ObservationActionTypes.RESET_ERROR,
    payload: {},
});
